import { render, staticRenderFns } from "./varieties-select-index.vue?vue&type=template&id=c90680bc&scoped=true&"
import script from "./varieties-select-index.vue?vue&type=script&lang=js&"
export * from "./varieties-select-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90680bc",
  null
  
)

export default component.exports